import moment from 'moment-timezone';

// ----------------------------------------------------------------------

const timezone = 'Asia/Seoul';
// const timezone = 'America/New_York';

const formats: {[key: string]: string} = { 'daily': 'day', 'weekly': 'day', 'monthly': 'month', 'setting': 'minute' };

const lastDay = (date: Date) => new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();

const parsing = (date: Date) => {
  return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') + 'T' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ':' + String(date.getSeconds()).padStart(2, '0');
};

export function timezones(date: number | string, format: string) {
  return moment.tz(date, timezone).format(format);
}

export function format(date: Date, interval: string, type: string) {
  const sets: {[key: string]: {[key: string]: string}} = {
    'minute': { 'format': 'YYYY-MM-DDTHH:mm:', 'start': '00', 'end': '59' },
    'day': { 'format': 'yyyy-MM-DDT', 'start': '00:00:00', 'end': '23:59:59' },
    'month': { 'format': 'yyyy-MM-', 'start': '01T00:00:00', 'end': String(lastDay(date)).padStart(2, '0') + 'T23:59:59' }
  };
  const set = sets[formats[interval]];
  return timezones(parsing(date), set.format + set[type] + 'Z');
}